<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">
            <div class="container register step1">
				<div class="title">
					<h1>{{$t('TITLE.EUR.SIGNUP.REQUEST')}}</h1>
				</div>
				<div class="content" ng-init="">
					<div class="one-register">

                        <div class="register_step">
                            <ul>
                                <li class="active"><!-- 활성화 STEP class -->
                                    <em>1</em>
                                    <p>{{$t('TITLE.EUR.TERMS')}}</p>
                                </li>
                                <li>
                                    <em>2</em>
                                    <p>{{$t('TITLE.EUR.SIGN.UP')}}</p>
                                </li>
                                <li>
                                    <em>3</em>
                                    <p>{{$t('BUTTON.GLOBAL.REQUEST')}}</p>
                                </li>
                            </ul>
                        </div>
                        <p class="register_txt">
                            {{$t('SUBTITLE.EUR.STEP1.TO.CONTINUE')}} <a href="/erp/agreeViewTerms" target="_blank">{{$t('SUBTITLE.EUR.STEP1.TERMS.COND')}}.</a><br> 
                        </p>

                        <div class="one-checkBox check_agree">
                            <input type="checkbox" id="remIdChkYN" v-model="agreeYn">
                            <label for="remIdChkYN"><span></span>{{$t('SUBTITLE.EUT.STEP1.HAVE.READ')}}</label>
                        </div>

                        <p class="register_txt2">
                           {{$t('SUBTITLE.EUR.STEP1.YOUR.DATA')}} <a href="/erp/agreeViewPolicy" target="_blank">{{$t('FIELD.GLOBAL.ETC.062')}}.</a><br>
                        </p>

                        <div class="one-signin">
                            <button class="bt_next" @click="goNextStepSubmit">{{$t('BUTTON.GLOBAL.NEXT')}}</button>
                        </div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import Vue              from 'vue';
import { mapGetters }   from 'vuex';
import { SDLUtil }      from '@/utils';
import qs               from 'query-string';
import axios            from 'axios';
import store            from '@/vuex/store';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'EurJoinUserStep1',
    computed: {
        ...mapGetters({
            langCd  : 'getLangCd'
        })
    },
    data() {
        return {
            agreeYn: false
        };
    },
    methods: {
        goNextStepSubmit() {
            if (this.agreeYn) {
                localStorage.setItem('eurMyAgreeYn', 'Y');
                let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep2`;
                this.$router.push({ path: pathUrl, query: {}});
            } else {
                SDLUtil.alert('MESSAGE.EUR.CHECK.AGREE');
            }
        },
    },
    created() {
        if (SDLUtil.isLogin()) {
//            this.gotoMain();
        } else if (this.$route.params.loginId) {
            // Automatically enter the ID you entered when you passed the membership registration
            this.loginId = this.$route.params.loginId;
        }
    },
    mounted() {
        $('body').addClass('reaair_wrap');
        console.log('Step1.this.langCd ===> ', this.langCd);
        store.commit('LANG_CD', this.langCd);
        loadLanguageAsync(this.langCd);
//        this.localAutoLogin();
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/JoinUserStep1.vue